/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ProductSections {
    General = 'general',
    Token = 'token',
    LastActiveTime = 'lastActiveTime',
    SessionExpirationTime = 'sessionExpirationTime',
}
